<template>
    <div>
        <h3>Login to the Deepest Why</h3>
        username <small>(could also be your email)</small>
        <br>
        <input class="input-text" type="text" id="loginUsername" :ref="'loginUsername'" placeholder="username" />
        <br>
        Super Secret Password
        <br>
        <input class="input-text" type="password" id="loginPassword" :ref="'loginPassword'" placeholder="password" />
        <br>
        <button @click.prevent="submit">Submit</button>
        <button @click.prevent="clear">Reset</button>
        <br>
        <div :ref="'loginMessage'" id="loginMessage"></div>
        <p><a href="#" @click.prevent="reset">reset</a> your password.</p>

    </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
export default {
    name:'login',
    data() {
        return {

        }
    },
    computed: {
    ...mapGetters(['getVisitorStatus', 'getUserStatus', 'getHost'])

    },
    methods: {
    ...mapActions(['updateUserStatus', 'showLoginForm', 'showResetForm', 'updateVisitorStatus']),
        async submit(){
            console.log("submit");
            let id = this.$cookies.get("dw_id");
            let creds = {
                id : id,
                username: this.$refs["loginUsername"].value,
                cred: this.$refs["loginPassword"].value,
                sessionid: this.$cookies.get("initial")
            }
            console.log(this.getHost, creds);
            let HOST = this.getHost;
            console.log(HOST);
            let testLogin = await axios.post(`${HOST}/userLogin`, {creds});
            console.log(testLogin.data);
            if (testLogin.data.message === "yay"){
                this.updateUserStatus("auth");
                this.$cookies.set("authStatus", "auth");
                this.$cookies.set("dw_id", testLogin.data.id);
                this.$cookies.set("started", testLogin.data.started);
                this.$cookies.set('session', testLogin.data.session);
                this.$cookies.remove('initial');
                this.showLoginForm(false);
                this.$nextTick(() => this.getUserStatus);
                this.$nextTick(() => this.getVisitorStatus);
            } else {
                this.$refs["loginMessage"].style="color:red";
                this.$refs["loginMessage"].innerHTML = "the username and provided do not match";
            }
        },
        clear(){
            this.$refs["loginUsername"].value = "";
            this.$refs["loginPassword"].value = "";
        },
        reset(){
            console.log("reset");
                let d = new Date();
                let expires = d.setTime(d.getTime() + (1*24*60*60*1000));
                this.$cookies.set("dw_id", "reset", "expires="+expires.toString()); //CHANGED TO PENDING

                this.updateUserStatus("notauth");
                this.$cookies.set("authStatus", "notauth", "expires="+expires.toString());
                this.updateVisitorStatus("reset");
                this.$nextTick(() => this.getUserStatus);
                this.$nextTick(() => this.getVisitorStatus);
                this.showResetForm(true);
                location.reload();
        }

    }
}
</script>

<style scoped>
.input-text {
    border: solid 1px darkgrey;
    height: 20px;
    width: 150px;
    margin: 5px;
    padding: 2px;
}
</style>